import { useState, useRef, Fragment } from 'react'
import { isSafari } from 'react-device-detect'
import { Popper, Grow, ClickAwayListener } from '@material-ui/core'
import {
  Icon,
  Wrapper,
  Title,
  DropDownIcon,
  POPPER_Z_INDEX,
  ListItem,
  MenuList,
  ActiveItemIcon,
  Paper,
} from './LanguageSelect.style'
import { useSelect } from './LanguageSelect.utils'

interface LanguageSelectProps {}

const LanguageSelect = (props: LanguageSelectProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)
  const { current, options, onSelect } = useSelect()

  const handleClose = () => {
    setIsOpen(false)
  }

  const TransitionComponent = isSafari ? Fragment : Grow

  return (
    <>
      <Wrapper ref={anchorRef} onClick={() => setIsOpen(!isOpen)} {...props}>
        <Icon />
        <Title>{current.title}</Title>
        <DropDownIcon isOpen={isOpen} />
      </Wrapper>
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement={'bottom-end'}
        style={{ zIndex: POPPER_Z_INDEX }}
      >
        {({ TransitionProps }) => (
          <TransitionComponent {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={isOpen}>
                  {options.map(({ title, value }) => {
                    const isActive = value === current.value
                    return (
                      <ListItem
                        onClick={() => {
                          handleClose()
                          onSelect(value)
                        }}
                        button
                        isActive={isActive}
                        key={`lng-select-item-${value}`}
                      >
                        {title}
                        {isActive && <ActiveItemIcon />}
                      </ListItem>
                    )
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </TransitionComponent>
        )}
      </Popper>
    </>
  )
}
export default LanguageSelect
